import mappedItemTypes from 'services/items/mappedItemTypes';
import { PortfolioItemSelectStep } from '../PortfolioItemSelectStep';
import { PCW_STEPS } from '../constants';

export function AncillariesStep() {
    return (
        <PortfolioItemSelectStep
            stepId={PCW_STEPS.PCW_ANCILLARIES_STEP_ID}
            itemTypeIds={[mappedItemTypes.ANCILLARY_RESERVE.id]}
        />
    );
}
